import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { ArrowLeftIcon } from "design-system/icons";
import { moovsBlue, granite } from "design-system/colors";
import InstalledChip from "../../MoovsMarketAppList/components/MoovsMarketAppListItem/components/InstalledChip";
import { MoovsMarketAppData } from "../../MoovsMarketAppList/hooks/useMoovsMarketApps";

interface AppInfoHeaderProps {
  onBack: () => void;
  isActive: boolean;
}

export const AppInfoHeader: React.FC<AppInfoHeaderProps> = ({ onBack, isActive }) => (
  <Box display="flex" width="100%" flexDirection="column">
    <Box display="flex" justifyContent="space-between" my={4}>
      <Button onClick={onBack}>
        <Box display="flex">
          <Box display="flex" alignItems="center">
            <ArrowLeftIcon color={moovsBlue} size="small" />
          </Box>
          <Box display="flex" alignItems="center" ml={1}>
            <Typography sx={{ color: moovsBlue, fontWeight: 500, fontSize: "16px" }}>
              Moovs Market
            </Typography>
          </Box>
        </Box>
      </Button>
      <Box display="flex" alignItems="center">
        {isActive && <InstalledChip />}
      </Box>
    </Box>
  </Box>
);

interface AppInfoContentProps {
  app: MoovsMarketAppData;
  isMobileView: boolean;
}

export const AppInfoContent: React.FC<AppInfoContentProps> = ({ app, isMobileView }) => (
  <Box
    display="flex"
    flexDirection="column"
    justifyContent={isMobileView ? "space-between" : undefined}
    mt={4}
    height="100%"
  >
    <Box>
      <Box height="70px" width="70px">
        <img src={app.icon} alt={app.name + "icon"} />
      </Box>
      <Box my={3}>
        <Typography variant="h1">{app.name}</Typography>
      </Box>
      <Box mb={3}>
        <Typography variant="body1" color={granite} maxWidth={650}>
          {app.longDescription || app.description}
        </Typography>
      </Box>
    </Box>
  </Box>
);